<div class="container container-fixed">
  <div class="row" [hidden]="generalConfigurations().length === 0">
    <div class="col-sm-12">
      <ep-datafield-group-container [datafieldGroups]="generalConfigurations()" [numberOfColumns]="3" [formValidationGroup]="validationFormGroup"></ep-datafield-group-container>
    </div>
  </div>
  <div class="row" [hidden]="specificConfigurations().length === 0">
    <div class="col-sm-12">
      <ep-datafield-group-container [datafieldGroups]="specificConfigurations()" [numberOfColumns]="3" [formValidationGroup]="validationFormGroup"></ep-datafield-group-container>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      @if (isEditing()) {
      <button class="btn btn-primary" type="button" (click)="save()" [disabled]="!validationFormGroup.valid">Save</button>
      <button class="btn btn-link" type="button" (click)="cancel()">Cancel</button>
      }
      @else {
      <button class="btn btn-primary" type="button" (click)="edit()"
        *bizPermissionRequired="['Partner_Action_ConfigurationKeysEdit', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner">Edit</button>
      }
    </div>
  </div>
</div>
